var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('chip',{class:_vm.chipClass},[_vm._v(_vm._s(_vm.text))])]},proxy:true},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.info)+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }